
import { defineComponent } from "vue";
import Report from "./Report.vue";
import OrderReportFilter from "./OrderReportFilter.vue";
import { ReportType } from "./ReportType";
import OrderReportInfoDialog from "@/components/info/OrderReportInfoDialog.vue";

export default defineComponent({
  components: {
    Report,
    OrderReportFilter,
    OrderReportInfoDialog,
  },
  computed: {
    reportType(): any {
      return ReportType.OrderReport;
    },
  },
  methods: {
    onReport(planId: any, options: any) {
      this.$refs.reportComponent.onReport(planId, options);
    },
    onStop() {
      this.$refs.reportComponent.onStop();
    },
  },
});
